import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=bc233ee2&scoped=true&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"
import style0 from "./Settings.vue?vue&type=style&index=0&id=bc233ee2&prod&lang=scss&"
import style1 from "./Settings.vue?vue&type=style&index=1&id=bc233ee2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc233ee2",
  null
  
)

export default component.exports